import { Dispatch, SetStateAction } from "react";
import Axios from "../Axios";
import ICalendarFactory from "../components/planning/other/calendar/ICalendarFactory.tsx";
import { AxiosResponse } from "axios";

interface FecthProps {
  setRoles?: Dispatch<SetStateAction<never[]>>
  setUsers?: Dispatch<SetStateAction<never[]>>
  setAbilities?: Dispatch<SetStateAction<never[]>>
  setUsersRoles?: Dispatch<SetStateAction<never[]>>
  setUsersAbilities?: Dispatch<SetStateAction<never[]>>
  setRolesTasks?: Dispatch<SetStateAction<never[]>>
  setRolesAbilities?: Dispatch<SetStateAction<never[]>>
  setTasksRoles?: Dispatch<SetStateAction<never[]>>
  setTasksUsers?: Dispatch<SetStateAction<never[]>>
  setTypeAction?: Dispatch<SetStateAction<never[]>>
  setLocations?: Dispatch<SetStateAction<never[]>>
}


class APIRequest {
  static config = {
    headers: {
      "Content-Type": "application/json",
      "auth-token": sessionStorage.getItem('token')
    },
    withCredentials: true
  };

  static getDataFromAPI = async (path: string, setValue: (value) => {}, errorMsg?: string, sort?: (a, b) => number) => {
    if (sort == null) {
      sort = (a, b) => {
        if (a.name < b.name) return -1;
        return (a.name > b.name) ? 1 : 0;
      }
    }

    try {
      const response = await Axios.get(`/api/` + path, APIRequest.config);
      if (response.status === 200) {
        setValue([...response.data].sort(sort));
      }
      return response;
    } catch (error) {
      console.error(errorMsg + ':', error);
    }
  }


  static async fetchData({ setRoles, setUsers, setAbilities, setUsersRoles, setUsersAbilities, setRolesTasks, setTypeAction, setLocations }: FecthProps) {
    const response: (AxiosResponse<any, any> | undefined)[] = [];

    if (setRoles != null) response.push(await this.getDataFromAPI('roles', setRoles, 'get roles failed'));
    if (setUsers != null) response.push(await this.getDataFromAPI('users/full', setUsers, 'get users failed'));
    if (setAbilities != null) response.push(await this.getDataFromAPI('abilities', setAbilities, 'get abilities failed'));

    if (setUsersRoles != null) response.push(await this.getDataFromAPI('users_roles', setUsersRoles, 'get users roles failed'));
    if (setUsersAbilities != null) response.push(await this.getDataFromAPI('users_abilities', setUsersAbilities, 'get users abilities failed'));

    //if (setRolesAbilities != null) response.push(await this.getDataFromAPI('roles_abilities', setRolesAbilities, 'get roles abilities failed'));
    //if (setTasksRoles != null) response.push(await this.getDataFromAPI('tasks_roles', setTasksRoles, 'get tasks roles failed'));
    //if (setTasksUsers != null) response.push(await this.getDataFromAPI('tasks_users', setTasksUsers, 'get tasks roles failed'));

    if (setTypeAction != null) response.push(await this.getDataFromAPI('fp/type_actions/getall/', setTypeAction, 'get all action failed'));
    if (setLocations != null) response.push(await this.getDataFromAPI('fp/location/getall/', setLocations, 'get all locations failed'));
    if (setRolesTasks != null) response.push(await this.getDataFromAPI('roles_tasks/full', setRolesTasks, 'get roles tasks failed'));

    return response;
  }

  static async getSettingValueByName(name: string): Promise<number> {
    const response = await Axios.get(`/api/setting/?name=${name}`, APIRequest.config);

    //console.log(name + ' ' + response)
    if (response.status === 200) {
      return parseInt(response.data.value);
    }
    return 0;
  }



  static async getPlanningFromDate(date: Date) {
    const monday = ICalendarFactory.getMonday(date);
    const id = monday.getFullYear() + '_' + ICalendarFactory.getWeek(monday);

    return await APIRequest.getPlanningFromId(id);
  }

  static async getPlanningFromId(id: string) {
    const response = await Axios.get(`/api/fp/planning/?id_plannings=${id}`, APIRequest.config);

    if (response.status === 200) {
      return response.data;
    }
    else console.error('error during get planning ' + id + '\n' + response);
  }

  // ================== TASK API ================= //

  static async deleteTask(task, updateData) {
    console.log("deleteTask");

    try {
      const response = await Axios.delete(`/api/caseplanning/?id=${task.id}`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem('token')
        },
        withCredentials: true
      });

      if (response.status === 200) {
        return updateData();
      }
    }
    catch (error) {
      console.error("Error during deleting task:", error);
    }
  }


  static async addPlanning(date : Date) : Promise<string | null> {
    const monday = ICalendarFactory.getMonday(date);
    const id_planning = monday.getFullYear() + '_' + ICalendarFactory.getWeek(monday);

    try {
      const response = await Axios.post(`/api/fp/planning_create`, {id_plannings: id_planning, name: id_planning}, APIRequest.config);

      if (response.status === 200) {
        console.log("planning created")
        return id_planning;
      }
      //console.log(response);
    }

    catch (error) {
      console.error("Error during creating planning:", error);
    }
    return null;
  }


  static async updateRolesTask(id_case_plannings, roles, setTasksRoles) : Promise<string | null> {
    if (roles != null){
      await Axios.delete(`api/roles_tasks/task/?id_task=${id_case_plannings}`, APIRequest.config);
      await Axios.post(`api/roles_tasks/all/`, {id_task: id_case_plannings, rolesTasks: roles}, APIRequest.config);
    }

    const taskRolesIds = { id_case_plannings: id_case_plannings, roles: roles };

    await this.fetchData({ setTasksRoles });
    return null;
  }

  static async updateTask(task, changes, updateData) {
    if (changes.start && new Date(changes.start) < new Date()) {
      console.error("Cannot update task: start date is in the past.");
      return;
    }

    if (changes.end && new Date(changes.end) < new Date()) {
      console.error("Cannot update task: end date is in the past.");
      return;
    }

    if (changes && Object.keys(changes).length > 0) {
      if (task.raw.id_plannings == null) 
        changes.raw.id_plannings = await APIRequest.addPlanning(task.start);

      let taskRoles = [];
      const setTasksRoles = (tr) => { taskRoles = tr };

      let data = ICalendarFactory.objectEventToTask({ ...task, ...changes });

      if (data) {
        try {
          console.log(data)

          const response = (data.id_case_plannings == null) ?
            await Axios.post(`/api/caseplanning/?id=${data.id_case_plannings}`, data, APIRequest.config) :
            await Axios.put(`/api/caseplanning/?id=${data.id_case_plannings}`, data, APIRequest.config);

          if (response.status === 200) {
            await APIRequest.updateRolesTask(response.data.id_case_plannings, data.rolesTasks, setTasksRoles)
            console.log("task created")
          }
          updateData(response.data.id_case_plannings, data, taskRoles, [], data.id_case_plannings == null);
          //console.log(response);
        }

        catch (error) {
          console.error("Error during modify task:", error);
        }
      }
    }
  }

  static async updateTaskRolesByTask(id_case_plannings, roles, setTasksRoles) {
    const taskRolesIds = { id_case_plannings: id_case_plannings, roles: roles };
    console.log(taskRolesIds)
    //TODO add this and abilities
    //const response_taskUser = await this.updateTaskUserByTask(response.data.id_case_plannings, data.users, setTasksUsers);

    //TODO change the path
    const response = await Axios.put(`api/tasks_roles/roles`, taskRolesIds, APIRequest.config);
    console.log(response)

    await this.fetchData({ setTasksRoles });
    return response;
  }

  static async getTaskRolesByTask(id_case_plannings) {

    const response = await Axios.get(`api/roles_tasks/full/task/?id_task=${id_case_plannings}`, APIRequest.config);
    //console.log(response.data)

    return response.data;
  }
  static async getTasksRolesFull() {

    const response = await Axios.get(`api/roles_tasks/full`, APIRequest.config);
    //console.log(response.data)

    return response.data;
  }

  static async updateTaskUserByTask(id_case_plannings, users, setTasksUsers) {
    const taskUsersIds = { id_case_plannings: id_case_plannings, users: users };
    const response = await Axios.put(`api/tasks_users/users`, taskUsersIds, APIRequest.config);
    //console.log(response)

    await this.fetchData({ setTasksUsers });
    return response;
  }


  // =================== USER API ==================== //
  static async updateUser(data, callBack) {

    if (data && Object.keys(data).length > 0) {
      if (data) {
        try {
          const response = (data.id == null) ?
            await Axios.post(`/api/users/`, data, APIRequest.config) :
            await Axios.put(`/api/users/?id=${data.id}`, data, APIRequest.config);

          if (response.status === 200) {
            const response_userRoles = await this.updateUserRolesByUser(response.data.id, data.roles);
            const response_userAbilities = await this.updateUserAbilitiesByUser(response.data.id, data.abilities);

            if (response_userRoles.status === 200 && response_userAbilities.status === 200) {
            }
            callBack(response.data);

            return;
          }
        }

        catch (error) {
          console.error("Error during modify user:", error);
        }
      }
    }
  }

  static async updateUserRolesByUser(id, roles) {
    const taskRolesIds = { id: id, roles: roles };
    const response = await Axios.put(`api/users_roles`, taskRolesIds, APIRequest.config);
    return response;
  }


  static async updateUserAbilitiesByUser(id, users) {
    const taskUsersIds = { id: id, users: users };
    const response = await Axios.put(`api/users_abilities`, taskUsersIds, APIRequest.config);

    return response;
  }
}

export default APIRequest;